import { useSubmitLogInMutation } from '@twisto/api-graphql'

import { useFlow } from '../../flow/flow.context'

import { useSubmittingWrapper } from './submitting-wrapper.hook'

export const useSubmitLogIn = () => {
  const { sessionId } = useFlow()
  const [logIn] = useSubmitLogInMutation()
  const submittingWrapper = useSubmittingWrapper()

  return async () =>
    submittingWrapper(
      logIn({
        variables: {
          auth: {
            sessionId,
          },
        },
      })
    )
}
